import axios from './axios'
export const TOKEN_KEY = '@medsis_authentication_token_key'
const REPORT_OUTSIDE_KEY = 'reportOutsideTheSystem'
const REMOTE_POINT_REPORT_OUTSIDE_KEY = 'remotePointReportOutsideTheSystem'

let reportOutsideCache = { clientId: null, enabled: null }
let reportOutsidePromise = null

export const isReportOutsideTheSystemEnabled = () =>
  localStorage.getItem(REPORT_OUTSIDE_KEY) === 'true' ||
  localStorage.getItem(REMOTE_POINT_REPORT_OUTSIDE_KEY) === 'true'

export const persistReportOutsideTheSystemFlags = client => {
  const clientId = client?.id || localStorage.getItem('clientId')
  let enabled = false

  if (client?.reportOutsideTheSystem) {
    localStorage.setItem(REPORT_OUTSIDE_KEY, 'true')
    localStorage.setItem(REMOTE_POINT_REPORT_OUTSIDE_KEY, 'false')
    enabled = true
  } else if (
    client?.type === 'TELEMEDICINE_CENTER' &&
    client?.telemedicineRemotePoints?.length > 0
  ) {
    enabled = client.telemedicineRemotePoints.some(
      point => point?.reportOutsideTheSystem === true
    )
    localStorage.setItem(REPORT_OUTSIDE_KEY, 'false')
    localStorage.setItem(REMOTE_POINT_REPORT_OUTSIDE_KEY, String(enabled))
  } else {
    localStorage.setItem(REPORT_OUTSIDE_KEY, 'false')
    localStorage.setItem(REMOTE_POINT_REPORT_OUTSIDE_KEY, 'false')
  }

  reportOutsideCache = { clientId, enabled }
  return enabled
}

export const resetReportOutsideTheSystemCache = () => {
  reportOutsideCache = { clientId: null, enabled: null }
  reportOutsidePromise = null
}

export const loadReportOutsideTheSystemFlags = () => {
  const clientId = localStorage.getItem('clientId')
  if (!clientId || clientId === 'undefined' || clientId === 'null') {
    return Promise.resolve(false)
  }

  if (
    reportOutsideCache.clientId === clientId &&
    reportOutsideCache.enabled !== null
  ) {
    return Promise.resolve(reportOutsideCache.enabled)
  }

  if (reportOutsidePromise) return reportOutsidePromise

  const token = localStorage.getItem(TOKEN_KEY)
  reportOutsidePromise = axios
    .get(`/clients?id=${clientId}`, {
      headers: token ? { Authorization: `Bearer ${token}` } : {}
    })
    .then(res => {
      const data = res.data?.[0]
      if (data?.type && !localStorage.getItem('clientType')) {
        localStorage.setItem('clientType', data.type)
      }
      return persistReportOutsideTheSystemFlags(data)
    })
    .catch(e => {
      console.log(e)
      return isReportOutsideTheSystemEnabled()
    })
    .finally(() => {
      reportOutsidePromise = null
    })

  return reportOutsidePromise
}

export const isAuthenticated = () =>
  !!localStorage.getItem(TOKEN_KEY) &&
  localStorage.getItem(TOKEN_KEY) !== null &&
  localStorage.getItem(TOKEN_KEY) !== undefined &&
  !!localStorage.getItem('hashCode') &&
  localStorage.getItem('hashCode') !== null &&
  localStorage.getItem('hashCode') !== undefined

export const getToken = () => localStorage.getItem(TOKEN_KEY)

export const setCredentials = (token, user) => {
  localStorage.setItem(TOKEN_KEY, token)
  Object.keys(user).forEach(key => localStorage.setItem(key, user[key]))
  resetReportOutsideTheSystemCache()

  if (user.clientId) {
    loadReportOutsideTheSystemFlags()
  }
}

export const setHashCode = hashToken => {
  localStorage.setItem('hashCode', hashToken)
  window.location.hash = '/'
}

export const logout = () => {
  if (localStorage.getItem('hashCode')) {
    const headers = {
      Authorization: `Bearer ${localStorage.getItem(TOKEN_KEY)}`
    }
    axios.put(
      `/accounts/authenticate/hash-code?hashCode=${localStorage.getItem(
        'hashCode'
      )}`,
      {},
      {
        headers: headers
      }
    )
  }
  localStorage.removeItem('clientType')
  localStorage.removeItem(TOKEN_KEY)
  localStorage.removeItem('hashCode')
  localStorage.removeItem(REPORT_OUTSIDE_KEY)
  localStorage.removeItem(REMOTE_POINT_REPORT_OUTSIDE_KEY)
  resetReportOutsideTheSystemCache()
}

export const getUserData = () => {
  const {
    id,
    username,
    name,
    accountId,
    clinicId,
    clientId,
    clientType,
    role,
    enableToReport
  } = localStorage

  return {
    userId: id,
    username,
    name,
    accountId,
    clinicId,
    clientId,
    clientType,
    role,
    enableToReport: enableToReport === 'true'
  }
}
